var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1625 1.89856H4.83713C3.21414 1.89856 1.89844 3.21427 1.89844 4.83725V37.1627C1.89844 38.7856 3.21414 40.1014 4.83713 40.1014H37.1625C38.7855 40.1014 40.1013 38.7856 40.1013 37.1627V4.83725C40.1013 3.21427 38.7855 1.89856 37.1625 1.89856Z",
    stroke: "#215250",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8359 32.1425V25.7754C13.8359 24.8963 14.5486 24.1836 15.4277 24.1836H26.5702C27.4493 24.1836 28.162 24.8963 28.162 25.7754V32.1425C28.162 33.0215 27.4493 33.7343 26.5702 33.7343H15.4277C14.5486 33.7343 13.8359 33.0215 13.8359 32.1425Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2266 24.1835V21C16.2266 18.3626 18.3646 16.2246 21.0019 16.2246C23.6393 16.2246 25.7773 18.3626 25.7773 21V24.1835",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1016 9.85749H1.89844V4.83725C1.89844 3.21427 3.21414 1.89856 4.83713 1.89856H37.1625C38.7855 1.89856 40.1013 3.21427 40.1013 4.83725L40.1016 9.85749Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureOnline);
export default __webpack_public_path__ + "static/media/secure-online.fe9563eb6f42fc450b4cde0771aca61f.svg";
export { ForwardRef as ReactComponent };